module.exports = __webpack_public_path__ + "static/media/design_community.dc7f5974.png";